import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "This study requires adblock to be disabled", "Screenout", "User failed adblock check", "app.error.adblocker")